import methods from '@/services/methods'

export default {
  updateFreshchatId (payload) {
    return methods.sendPost('settings/freshchat_id', payload)
  }
}
